import axios from 'axios';
import { endpoint, remoteCreate, remoteModifyPatch } from "./utils.js";
import { objComparatorICase } from "../utils.js";

export async function createUser(useAlerts, payload) {
  await remoteCreate(useAlerts, endpoint("internal/current/users/"), payload, 'User', 'User');
}

export async function fetchUsers(
  getparams = '?has_guest_feat=0&has_pmschild_feat=0&has_gireve_feat=0'
) {
  // OPTIMIZE: Can be good to not show by default the has_pmsadmin_feat too? The filterset is not implemented on BackEnd.
  const res = await axios.get(endpoint(`internal/current/users/${getparams}`), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorICase(a, b, 'username'));
}

export async function fetchUser(userId) {
  const res = await axios.get(endpoint(`internal/current/users/${userId}/`), {
    withCredentials: true
  });
  return res.data;
}

export async function modifyPatchUser(useAlerts, payload, user_id) {
  await remoteModifyPatch(useAlerts, endpoint(`internal/current/users/${user_id}/`), payload, 'User', 'User');
}

export async function expireUser(useAlerts, user_id) {
  try {
    const res = await axios.post(endpoint(`internal/current/users/${user_id}/expire/`), {}, {
      withCredentials: true
    });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(`User expired!`, `User ID = ${user_id}`);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
    throw e;
  }
}
